import React from 'react';
import { useTranslation } from 'react-i18next';

import PanelCard from '../../performance-operations/components/PanelCard';
import { Badge, KpiSub, KpiValue } from '../../performance-operations/styles';
import { formatNumber } from '../../performance-operations/config';
import { hasValue, metricOf } from '../config';

// P7a — E15 üst alan: M56 açık bulgu, M57 inceleme kapsamı, M43 aksiyona dönüşüm, M44 aksiyon tamamlama (ve yönetim görünümünde
// M71–M74). Kart standardı (analiz §25): etiket, metrik kimliği, değer, pay/payda (n). Payda 0 → "Veri Yok"; sıfır puan uydurulmaz.
export default function AiCenterKpis({ codes, metrics, loading, error, onRetry, panelPrefix = 'kpi' }) {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;
  return (
    <>
      {codes.map((code) => {
        const m = metricOf(metrics, code);
        const value = hasValue(m)
          ? (m.unit === 'count' ? formatNumber(m.value, lang, 0) : `%${formatNumber(m.value, lang)}`)
          : t('performance.aiCenter.noData');
        return (
          <PanelCard
            key={code}
            panelKey={`${panelPrefix}-${code}`}
            kpi
            compact
            span={3}
            title={t(`performance.aiCenter.kpi.${code}`)}
            loading={loading}
            error={error}
            onRetry={onRetry}
            actions={<Badge $tone="info">{code}</Badge>}
          >
            <KpiValue data-kpi={code}>{value}</KpiValue>
            <KpiSub>
              {m && m.unit !== 'count' && m.denominator != null
                ? t('performance.aiCenter.kpiRatio', { num: formatNumber(m.numerator, lang, 2), den: formatNumber(m.denominator, lang, 2) })
                : null}
            </KpiSub>
            <KpiSub>{t(`performance.aiCenter.kpiHint.${code}`)}</KpiSub>
          </PanelCard>
        );
      })}
    </>
  );
}
